import { API_URL_COPILOT } from "~/constants/url";
import { BaseApi } from "./baseApi";

const copilotRequest = BaseApi({ baseUrl: API_URL_COPILOT });

export const acknowledgeAlerts = async (alertIds: string[]) => {
  const response = await copilotRequest({
    action: "ackAlerts",
    method: "POST",
    body: JSON.stringify({
      alertIds,
    }),
  });

  return response;
};

export const createTestAlert = async () => {
  const response = await copilotRequest({
    action: "createAlert",
    method: "POST",
    params: new URLSearchParams({
      messageContent: `test1 ${new Date().toISOString()}`,
    }),
  });

  return response;
};
